/**
 * Timing — stable clock with dt clamped to avoid huge jumps after tab visibility
 * changes.
 */

export interface TimingState {
  startTime: number;
  lastTime: number;
  /** Frame counter since start. */
  frames: number;
  /** Smoothed FPS (EMA). */
  fps: number;
}

export function createTiming(): TimingState {
  const now = performance.now();
  return {
    startTime: now,
    lastTime: now,
    frames: 0,
    fps: 60,
  };
}

const MAX_DT = 1 / 30; // 33ms — anything larger is a tab-resume, ignore

export function tickTiming(state: TimingState): { t: number; dt: number } {
  const now = performance.now();
  let dt = (now - state.lastTime) / 1000;
  if (dt > MAX_DT) dt = MAX_DT;
  state.lastTime = now;
  state.frames++;
  // EMA over ~30 frames
  const inst = dt > 0 ? 1 / dt : 60;
  state.fps = state.fps * 0.95 + inst * 0.05;
  const t = (now - state.startTime) / 1000;
  // Store t on the state so callers can read it via engine.timing.t
  // (e.g. customDraw hooks). Without this, t is undefined and the
  // chain's uTime uniform becomes NaN, producing a black screen.
  (state as TimingState & { t: number }).t = t;
  return { t, dt };
}
